export const SESSION_HEADER_EVENT_ID = 'Cvent-Event-ID';

export const REQUESTED_ACTIONS = {
  REGISTER: 'REGISTER',
  UNREGISTER: 'UNREGISTER',
  WAITLIST: 'WAITLIST',
  LEAVE_WAITLIST: 'LEAVE_WAITLIST'
};

export const REGISTRATION_SOURCE_TYPES = {
  INCLUDED: 'Included',
  SELECTED: 'Selected'
};
